import { postFakeLogin, postJwtLogin, completeLoginApi } from "helpers/fakebackend_helper";
import { loginSuccess, apiError, logoutUserSuccess, resetLoginFlag } from "./reducer";
import { setAuthorization } from "helpers/api_helper";
import axios from 'axios';

export const loginuser = (user: any, history: any,navigate: any) => async (dispatch: any) => {
    try {
        const response: any = await postJwtLogin({
            user: user.email,
            password: user.password,
            otp: user.otp,
        })
        if(response.status === 'session_limit'){
            return response
        }
        else if(response.enable_two_fact){
            return response
        }
        else if(response.access_token){
            if (response.access_token) {
                localStorage.setItem("access_token", response.access_token);
                setAuthorization(response.access_token);
            }
            localStorage.setItem("authUser", response.username);
            localStorage.setItem("userole_", response.role);
            localStorage.setItem("userinfo_", response.user_info);
            localStorage.setItem("cstpack", JSON.stringify(response.cstpack));
            localStorage.setItem("userdata", JSON.stringify(response.user));
            localStorage.setItem("enable_two_fact", JSON.stringify(response.user.is_two_fact_enable))
            dispatch(loginSuccess(response));
            if(response.role === 'adm'){
                navigate("/adashboard")
            } else if(response.role === 'exp'){
                navigate("/edashboard")
            } else if(['cst', 'prt', 'emp'].includes(response.role)){
                navigate("/")
            }
        }
    } catch (error:any) {
        const errorMessage = error?.message || "Login failed. Please try again.";
        dispatch(apiError(errorMessage));
    }
}

export const logoutUser = () => {
    return async (dispatch: any) => {
        try {
            if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
                const response = await axios.post('/accounts/logout_user', {}, { withCredentials: true });
                console.log('logout api hit hui h', response);

                if (response.status === "Logout_successful") {
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = "/login";
                    // dispatch(logoutUserSuccess(true));
                }
            }
        } catch (error:any) {
            console.log("Logout error:", error);
            if ( error?.response?.status === 403 || error?.response?.status === 401)
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = "/login";
                // dispatch(apiError(error));
            }
            // dispatch(apiError(error));
    };
};

export const resetLoginMsgFlag = () => {
    try {
        const response = resetLoginFlag();
        return response;
    } catch (error) {
        return error;
    }
};


export const completeLoginUser = (pendingToken: string, revokeJti: string, navigate: any, revokeAccessJti?: string) => async (dispatch: any) => {
    try {
        const response: any = await completeLoginApi(pendingToken, revokeJti, revokeAccessJti);
        if (response.access_token) {
            localStorage.setItem("access_token", response.access_token);
            setAuthorization(response.access_token);
            localStorage.setItem("authUser",      response.username);
            localStorage.setItem("userole_",      response.role);
            localStorage.setItem("userinfo_",     response.user_info);
            localStorage.setItem("cstpack",       JSON.stringify(response.cstpack));
            localStorage.setItem("userdata",      JSON.stringify(response.user));
            localStorage.setItem("enable_two_fact", JSON.stringify(response.user.is_two_fact_enable));
            dispatch(loginSuccess(response));
            if (response.role === 'adm')                       navigate("/adashboard");
            else if (response.role === 'exp')                  navigate("/edashboard");
            else if (['cst', 'prt', 'emp'].includes(response.role)) navigate("/");
        }
    } catch (error: any) {
        const errorMessage = error?.message || "Session completion failed. Please try again.";
        dispatch(apiError(errorMessage));
    }
};
